import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ChatFab from './ChatFab';
import reportWebVitals from './reportWebVitals';
import { WidgetController, NETAI_WIDGET_PREFILL_EVENT, PENDING_MESSAGE_KEY, PENDING_AUTO_SEND_KEY } from './widgetTypes';

declare global {
  interface Window {
    createChatWidget: (ipscope: string, env: string, search_level?: string) => void;
    NetAIWidget?: {
      openWithMessage: (message: string, autoSend?: boolean) => void;
    };
    __netAIWidgetController?: WidgetController | null;
  }
}

const setWidgetController = (controller: WidgetController | null) => {
  window.__netAIWidgetController = controller;
};

const openChatWithMessageFallback = (message: string, autoSend?: boolean) => {
  sessionStorage.setItem(PENDING_MESSAGE_KEY, message);
  if (autoSend) {
    sessionStorage.setItem(PENDING_AUTO_SEND_KEY, 'true');
  } else {
    sessionStorage.removeItem(PENDING_AUTO_SEND_KEY);
  }
  window.dispatchEvent(new CustomEvent(NETAI_WIDGET_PREFILL_EVENT, { detail: { message, autoSend } }));
  return Boolean(document.getElementById('chat-fab'));
};

window.NetAIWidget = {
  openWithMessage: (message: string, autoSend?: boolean) => {
    const controller = window.__netAIWidgetController;
    if (controller) {
      controller.openWithMessage(message, autoSend);
      return;
    }

    if (openChatWithMessageFallback(message, autoSend)) {
      console.warn('maiaWidget: Controller not registered yet, used FAB fallback.');
      return;
    }

    console.warn('maiaWidget: Chat widget is not loaded yet.');
  },
};

window.createChatWidget = function(ipscope: string, env: string, search_level: string='5') {
  console.log('Attempting to create chat widget with scope:', ipscope, 'and env:', env, 'and search_level:', search_level);
  
  localStorage.setItem('envDetails', env);

  const container = document.getElementById('chat-widget-container');
  if (container) {
    const chatContainer = document.createElement('div');
    chatContainer.id = 'chat-widget';
    container.appendChild(chatContainer);

    try {
      createRoot(chatContainer).render(
        <ChatFab
          scope={ipscope}
          env={env}
          search_level={search_level}
          onRegister={setWidgetController}
        />
      );
      console.log('Chat widget should now be created and rendered with env:', env, 'scope:', ipscope);
      return chatContainer;
    } catch (error) {
      console.error('Error rendering ChatFab:', error);
      return null;
    }
  } else {
    console.error('Chat widget container not found');
    return null;
  }
};

const rootElement = document.getElementById('main-react-app-dashboard');
if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
